import './styles.scss'
import React, { useState, useEffect } from 'react'
import { I18n } from 'react-redux-i18n'
import { Interval, DateTime } from 'luxon'

const CHANNEL_WITH_7_DAYS = ['facebook', 'instagram']

function getTotalDays(channel) {
  if (channel === 'facebook') return 7
  if (channel === 'instagram') return 7
  return 1
}

function getClassToDisplay(channel, duration) {
  const { days, hours } = duration

  if (days === 0) {
    // 1h remaining
    if (hours < 1) return 'red'

    // 4h remaining
    if (hours < 4) return 'orange'
  }

  return 'purple'
}

function getTimeToDisplay(channel, duration) {
  const { days, hours, minutes, seconds } = duration

  if (days === 0) {
    return `${addZero(hours)}:${addZero(minutes)}:${addZero(seconds)}`
  }

  if (CHANNEL_WITH_7_DAYS.includes(channel)) {
    if (days < 7) return `${days + 1} ${I18n.t('dashboard_days')}`

    return `${addZero(hours)}:${addZero(minutes)}:${addZero(seconds)}`
  }

  return ''
}

function addZero (num) {
  if (num < 10) return `0${num}`
  return num
}

const Counter = ({ lastMessageDate, channel }) => {
  const [, setCounter] = useState(Date.now())

  const currentDate = DateTime.now()
  const endDate = DateTime.fromISO(lastMessageDate).plus({ days: getTotalDays(channel) })
  const duration = Interval.fromDateTimes(currentDate, endDate)
    .toDuration(['years', 'months', 'days', 'hours', 'minutes', 'seconds', 'milliseconds'])
    .toObject()
  const endedTime = duration.seconds === undefined

  useEffect(() => {
    let timerId = null

    if (!endedTime) {
      timerId = setInterval(() => setCounter(Date.now()), 1000)
    }

    return () => timerId && clearInterval(timerId)
  }, [endedTime])

  const classToDisplay = getClassToDisplay(channel, duration)
  const timeToDisplay = getTimeToDisplay(channel, duration)

  if (!channel) return null

  return (
    <span className={`counter-timer counter-timer--${classToDisplay}`}>
      {!endedTime ? timeToDisplay : ''}
    </span>
  )
}

export default React.memo(Counter)
